var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.314 27.588C4.81101 26.5731 5.58282 25.718 6.54167 25.12C7.50052 24.5219 8.60793 24.2049 9.738 24.205H19.448L15.434 33.466C15.1243 34.1811 14.6135 34.7909 13.9638 35.2212C13.314 35.6515 12.5533 35.8839 11.774 35.89C9.755 35.907 5.613 35.926 5.613 35.926C2.184 35.927 0.63 37.46 0.63 37.46H0L4.314 27.588Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.059 33.632C45.812 29.167 37.221 11.911 35.032 7.69199C33.9354 5.44394 32.2426 3.54017 30.1382 2.18834C28.0337 0.836514 25.5984 0.0885356 23.098 0.0259945C22.0185 -0.0240961 20.9371 -0.0124103 19.859 0.0609945L15.218 10.772L15.943 10.738C21.487 10.48 25.451 13.805 27.88 18.487C30.07 22.706 38.66 39.962 40.908 44.428C41.6576 46.0167 42.0663 47.7448 42.108 49.501H42.822L48.38 41.111C49.0343 40.1352 49.3366 38.9656 49.237 37.795C49.1115 36.3462 48.7135 34.9341 48.064 33.633",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.93fc35fa0a09d728b3805b34b917fb66.svg";
export { ForwardRef as ReactComponent };